// @ts-nocheck
/* eslint-disable */
export const outlineArrowUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m8 7.22-3.3 3.299-.943-.943L8 5.333l4.243 4.243-.943.943z"/></svg>`,
    name: 'outline-arrow-up' as const
};